import script from "./Farm.vue?vue&type=script&setup=true&lang=js"
export * from "./Farm.vue?vue&type=script&setup=true&lang=js"

export default script